import { ArrowLeftStartOnRectangleIcon } from '@heroicons/react/24/outline';
import { isEmpty } from '@/shared/utility';
import { logout } from '@/store/actions/auth';
import SideBarElement, {
  SideBarElementItemProps,
} from '@/components/shared/sidebar/SidebarElement';
import SidebarMenu from '@/components/shared/sidebar/SidebarMenu';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { selectUser } from '@/store/selectors/userSelectors';

const SidebarUser = () => {
  const intl = useIntl();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const sidebarElements: SideBarElementItemProps[] = [
    {
      icon: (
        <div className="bg-blue-light rounded-full h-9 w-12 font-bold text-white flex justify-center items-center text-xl">
          {user && user.firstName && user.firstName.charAt(0).toUpperCase()}
          {user && user.lastName && user.lastName.charAt(0).toUpperCase()}
        </div>
      ),
      to: '/settings',
      'data-cy': 'sidebar-settings',
      id: 'settings',
      'aria-label': 'User Settings page button',
      'aria-roledescription': 'Button to open logged in user settings. Invisible for guest users.',
      children: `${user?.firstName} ${user?.lastName}`,
      shouldShow: isAuthenticated,
    },
    {
      icon: <ArrowLeftStartOnRectangleIcon width={30} height={30} />,
      'data-cy': 'sidebar-logout',
      id: 'logout',
      'aria-label': 'User logout button',
      'aria-roledescription': 'Button to log the user out. Invisible for guest users.',
      children: intl.formatMessage({ id: 'header.logout' }),
      shouldShow: Boolean(isAuthenticated && user && !isEmpty(user)),
      onClick: () => dispatch(logout()),
    },
  ];

  if (!isAuthenticated) return null;

  return (
    <div>
      <div className="w-[80%] border-b-[1px] border-blue-light/30 mx-auto mb-2" />
      <SidebarMenu>
        {sidebarElements.map(({ children, ...elementProps }, index) => (
          <SideBarElement key={`sidebar-user-element-${index}`} {...elementProps}>
            {children}
          </SideBarElement>
        ))}
      </SidebarMenu>
    </div>
  );
};

export default SidebarUser;
